var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        [
          _c(
            "router-link",
            { staticClass: "infobox-link", attrs: { to: "/contracts" } },
            [
              _c(
                "Infobox",
                {
                  attrs: {
                    title: _vm.contracts.length,
                    message: _vm.contractMessage,
                    subtitle: _vm.$t(
                      "message.dashboard.infobox.contracts.subtitle"
                    ),
                    variant: "dark"
                  }
                },
                [_c("span", { staticClass: "infobox-icon ti-receipt" })]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        [
          _c(
            "router-link",
            { staticClass: "infobox-link", attrs: { to: "/contactpersons" } },
            [
              _c(
                "Infobox",
                {
                  attrs: {
                    title: _vm.contactPersons.length,
                    message: _vm.contactPersonsMessage,
                    subtitle: _vm.$t(
                      "message.dashboard.infobox.contactPersons.subtitle"
                    ),
                    variant: "dark"
                  }
                },
                [_c("span", { staticClass: "infobox-icon ti-user" })]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        [
          _c(
            "router-link",
            { staticClass: "infobox-link", attrs: { to: "/addresses" } },
            [
              _c(
                "Infobox",
                {
                  attrs: {
                    title: _vm.addresses.length,
                    subtitle: _vm.$t(
                      "message.dashboard.infobox.addresses.subtitle"
                    ),
                    variant: "dark"
                  }
                },
                [_c("span", { staticClass: "infobox-icon ti-home" })]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6aa370e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aa370e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/DashboardContent.vue
// module id = VrHS
// module chunks = 1